import React from 'react';

const PrivacyPolicy: React.FC<{ language: 'tr' | 'en' }> = ({ language }) => {
  return (
    <div className="p-8 max-w-4xl mx-auto">
      {language === 'tr' ? (
        <div>
          <h1 className="text-4xl font-bold mb-6">Gizlilik Politikası</h1>
          <p className="mb-4">
            "Haydi: Akıllı Görev Yöneticisi" olarak, kullanıcılarımızın gizliliğine büyük önem veriyoruz. Bu Gizlilik Politikası, uygulamamızı kullanırken hangi bilgileri topladığımızı, bu bilgileri nasıl kullandığımızı ve koruduğumuzu açıklamaktadır.
          </p>

          <h2 className="text-2xl font-semibold mb-4">1. Toplanan Bilgiler</h2>
          <p className="mb-4">
            Uygulamamızı kullanırken aşağıdaki türde bilgileri toplayabiliriz:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Kişisel Bilgiler:</strong> İsim, e-posta adresi ve iletişim bilgileri.</li>
            <li><strong>Görev Verileri:</strong> Eklediğiniz görevler, notlar ve hatırlatıcılar.</li>
            <li><strong>Cihaz Bilgileri:</strong> Cihaz türü, işletim sistemi, benzersiz cihaz tanımlayıcıları ve mobil ağ bilgileri.</li>
            <li><strong>Kullanım Verileri:</strong> Uygulamayı nasıl kullandığınıza dair bilgiler, erişim süreleri ve sayfalar.</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">2. Bilgilerin Kullanımı</h2>
          <p className="mb-4">
            Topladığımız bilgileri aşağıdaki amaçlar için kullanabiliriz:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>Hizmetimizin sağlanması ve sürdürülmesi.</li>
            <li>Hizmetimizin iyileştirilmesi, kişiselleştirilmesi ve genişletilmesi.</li>
            <li>Kullanıcılarımızla iletişim kurmak ve müşteri desteği sağlamak.</li>
            <li>Kullanıcı deneyimini analiz etmek ve anlamak.</li>
            <li>Güvenlik ihlallerini tespit etmek ve önlemek.</li>
            <li>Yasal yükümlülüklerimizi yerine getirmek.</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">3. Bilgilerin Paylaşımı</h2>
          <p className="mb-4">
            Kişisel bilgilerinizi üçüncü taraflarla paylaşmayız, ancak aşağıdaki durumlar istisnadır:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>Yasal süreçlere uymak veya yasal taleplere yanıt vermek gerektiğinde.</li>
            <li>Haklarımızı, gizliliğimizi, güvenliğimizi veya mülkiyetimizi korumak amacıyla.</li>
            <li>Hizmet sağlayıcılarımızın, taşeronlarımızın ve iş ortaklarımızın işlerini kolaylaştırmak için.</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">4. Verilerin Saklanması</h2>
          <p className="mb-4">
            Kişisel bilgilerinizi, bu Gizlilik Politikası'nda belirtilen amaçlar için gerekli olduğu sürece saklarız. Yasal yükümlülüklerimizi yerine getirmek, anlaşmazlıkları çözmek ve politikalarımızı uygulamak için gerekli olduğu durumlarda verilerinizi saklayabiliriz.
          </p>

          <h2 className="text-2xl font-semibold mb-4">5. Güvenlik</h2>
          <p className="mb-4">
            Kişisel bilgilerinizin güvenliğini korumak için makul önlemler alıyoruz. Ancak, internet üzerinden yapılan hiçbir veri iletiminin veya elektronik depolamanın %100 güvenli olduğunu garanti edemeyiz.
          </p>

          <h2 className="text-2xl font-semibold mb-4">6. Çocukların Gizliliği</h2>
          <p className="mb-4">
            Hizmetimiz 13 yaşın altındaki çocuklara yönelik değildir. 13 yaşın altındaki çocuklardan bilerek kişisel bilgi toplamıyoruz. Eğer bir ebeveyn veya vasisiyseniz ve çocuğunuzun bize kişisel bilgi verdiğini düşünüyorsanız, lütfen bizimle iletişime geçin.
          </p>

          <h2 className="text-2xl font-semibold mb-4">7. Uluslararası Veri Aktarımları</h2>
          <p className="mb-4">
            Kişisel bilgileriniz, ikamet ettiğiniz ülkenin dışındaki sunucularımıza aktarılabilir ve orada saklanabilir. Bu durumda, verilerinizin bu Gizlilik Politikası'na uygun olarak korunmasını sağlamak için gerekli önlemleri alırız.
          </p>

          <h2 className="text-2xl font-semibold mb-4">8. Haklarınız</h2>
          <p className="mb-4">
            Kişisel verilerinize erişme, düzeltme, silme veya işlemeyi kısıtlama hakkına sahipsiniz. Bu haklardan herhangi birini kullanmak isterseniz, lütfen bizimle iletişime geçin.
          </p>

          <h2 className="text-2xl font-semibold mb-4">9. Değişiklikler</h2>
          <p className="mb-4">
            Bu Gizlilik Politikası'nı zaman zaman güncelleyebiliriz. Değişiklikler bu sayfada yayınlanacaktır. Politikanın güncellenmesinden sonra Hizmetimizi kullanmaya devam etmeniz, değişiklikleri kabul ettiğiniz anlamına gelir.
          </p>

          <h2 className="text-2xl font-semibold mb-4">10. İletişim</h2>
          <p className="mb-4">
            Bu Gizlilik Politikası ile ilgili sorularınız veya endişeleriniz varsa, lütfen bizimle iletişime geçin:
          </p>
          <p>
          Email: <a href="mailto:haydiauth@gmail.com" className="text-blue-500">haydiauth@gmail.com</a>
          </p>
        </div>
      ) : (
        <div>
          <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
          <p className="mb-4">
            At "Haydi: Intelligent Task Manager", we value the privacy of our users highly. This Privacy Policy explains how we collect, use, and protect your information when you use our application.
          </p>

          <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
          <p className="mb-4">
            We may collect the following types of information when you use our application:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li><strong>Personal Information:</strong> Name, email address, and contact details.</li>
            <li><strong>Task Data:</strong> Tasks, notes, and reminders you add.</li>
            <li><strong>Device Information:</strong> Device type, operating system, unique device identifiers, and mobile network information.</li>
            <li><strong>Usage Data:</strong> Information on how you use the app, access times, and pages viewed.</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
          <p className="mb-4">
            We may use the collected information for the following purposes:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>To provide and maintain our Service.</li>
            <li>To improve, personalize, and expand our Service.</li>
            <li>To communicate with you and provide customer support.</li>
            <li>To analyze and understand user behavior.</li>
            <li>To detect and prevent security breaches.</li>
            <li>To comply with legal obligations.</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">3. Sharing of Information</h2>
          <p className="mb-4">
            We do not share your personal information with third parties except in the following cases:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>To comply with legal processes or governmental requests.</li>
            <li>To protect our rights, privacy, safety, or property.</li>
            <li>To facilitate the work of our service providers, contractors, and business partners.</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-4">4. Data Retention</h2>
          <p className="mb-4">
            We retain your personal information only for as long as necessary for the purposes set out in this Privacy Policy. We may retain and use your information to the extent necessary to comply with legal obligations, resolve disputes, and enforce our policies.
          </p>

          <h2 className="text-2xl font-semibold mb-4">5. Security</h2>
          <p className="mb-4">
            We take reasonable measures to protect your personal information. However, no method of transmission over the internet or electronic storage is 100% secure.
          </p>

          <h2 className="text-2xl font-semibold mb-4">6. Children's Privacy</h2>
          <p className="mb-4">
            Our Service is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.
          </p>

          <h2 className="text-2xl font-semibold mb-4">7. International Data Transfers</h2>
          <p className="mb-4">
            Your information may be transferred to and maintained on servers located outside of your state, province, country, or other governmental jurisdiction where data protection laws may differ. We take steps to ensure your data is treated securely and in accordance with this Privacy Policy.
          </p>

          <h2 className="text-2xl font-semibold mb-4">8. Your Rights</h2>
          <p className="mb-4">
            You have the right to access, correct, delete, or restrict the processing of your personal data. If you wish to exercise any of these rights, please contact us.
          </p>

          <h2 className="text-2xl font-semibold mb-4">9. Changes to This Privacy Policy</h2>
          <p className="mb-4">
            We may update our Privacy Policy from time to time. Changes will be posted on this page. Continued use of our Service after any changes signifies your acceptance of the new Privacy Policy.
          </p>

          <h2 className="text-2xl font-semibold mb-4">10. Contact Us</h2>
          <p className="mb-4">
            If you have any questions or concerns about this Privacy Policy, please contact us:
          </p>
          <p>
            Email: <a href="mailto:haydiauth@gmail.com" className="text-blue-500">haydiauth@gmail.com</a>
          </p>
        </div>
      )}
    </div>
  );
};

export default PrivacyPolicy;
